import { render, staticRenderFns } from "./environment-save-warning.vue?vue&type=template&id=39d6307f&scoped=true"
import script from "./environment-save-warning.vue?vue&type=script&lang=js"
export * from "./environment-save-warning.vue?vue&type=script&lang=js"
import style0 from "./environment-save-warning.vue?vue&type=style&index=0&id=39d6307f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d6307f",
  null
  
)

export default component.exports